import Login from '@/components/Login'
import userService from '@/service/userService'

export default [
  {
    path: '/login',
    name: 'login',
    component: Login,
    beforeEnter (to, from, next) {
      if (userService.isLogged()) {
        next({
          name: 'main'
        })
      } else {
        next()
      }
    }
  },
  {
    path: '/logout',
    name: 'logout',
    beforeEnter (to, from, next) {
      userService.logOut()
      next({
        name: 'login'
      })
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/loginLogout.js